import React from 'react';
import type { ColumnsType } from 'antd/es/table';
import { TableRowSelection } from 'antd/lib/table/interface';
import { Table } from 'antd';
import { PlanogramUI } from '../../context/PlanogramAutomation';
import * as S from '../../style';

export enum PlanogramTableType {
    PLANOGRAM = 'PLANOGRAM',
    SYSTEM = 'SYSTEM',
    EXPECTED_METRICS = 'EXPECTED_METRICS',
    CURRENT_METRICS = 'CURRENT_METRICS',
}

type PlanogramTableBlockProps = {
    title: string;
    columns: ColumnsType<PlanogramUI>;
    typeTable: PlanogramTableType;
    rowSelection?: TableRowSelection<PlanogramUI>;
    dataSource: PlanogramUI[];
    editTable: boolean;
    rowClassName: (record: PlanogramUI) => string;
    selectRow: (record: PlanogramUI) => void;
    loading: boolean;
    className?: string;
};

export function PlanogramTableBlock({
    title,
    columns,
    typeTable,
    rowSelection,
    dataSource,
    editTable,
    rowClassName,
    selectRow,
    loading,
    className,
}: PlanogramTableBlockProps) {
    return (
        <div style={{ marginRight: 23 }}>
            <S.TitleTable>{title}</S.TitleTable>
            <Table<PlanogramUI>
                columns={columns}
                rowSelection={rowSelection}
                dataSource={dataSource}
                bordered
                tableLayout="fixed"
                pagination={false}
                rowClassName={rowClassName}
                className={`${className ?? ''} ${
                    typeTable !== PlanogramTableType.PLANOGRAM
                        ? 'hidden-checkbox'
                        : ''
                }`}
                loading={loading}
                onRow={
                    editTable
                        ? (record) => ({
                              onClick: () => selectRow(record),
                          })
                        : undefined
                }
            />
        </div>
    );
}
